export var HTLCTransaction;
(function (HTLCTransaction) {
    HTLCTransaction["HTLCLock"] = "HTLCLock";
    HTLCTransaction["HTLCRedeem"] = "HTLCRedeem";
})(HTLCTransaction || (HTLCTransaction = {}));
